var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingGroupBalancingValve = function SvgDHeatingGroupBalancingValve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 101.96,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "606 106.94 592 98.96 592.01 114.95 606 106.94",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593,100.68l10.98,6.26-10.97,6.29v-12.55M592,98.96v16s14-8.01,14-8.01l-14-7.98h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "606 106.94 619.99 98.96 620 114.95 606 106.94",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.99,100.68v12.55s-10.98-6.29-10.98-6.29l10.98-6.26M619.99,98.96l-13.99,7.98,14,8.01v-16h0Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "599.83 117.36 609.41 102.72 610.45 103.4 612.55 97 607.53 101.49 608.58 102.17 599 116.82 599.83 117.36",
    fill: "#1d1d1b"
  })))));
};
export default SvgDHeatingGroupBalancingValve;